function panelChrome(tag: string): string {
  return `
    <div class="ub-panel__chrome" aria-hidden="true">
      <span></span><span></span><span></span>
      <em>${tag}</em>
    </div>`;
}

export function ugCapturePanel(): string {
  return `
    <div class="ub-panel reveal">
      ${panelChrome('Capture')}
      <div class="ub-panel__body">
        <svg viewBox="0 0 640 360" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <rect width="640" height="360" fill="#FFFFFF"/>
          <rect x="240" y="24" width="160" height="280" rx="24" fill="#0F172A"/>
          <rect x="256" y="48" width="128" height="220" rx="12" fill="#1E293B"/>
          <circle cx="320" cy="140" r="28" fill="#10B981" opacity="0.9"/>
          <ellipse cx="320" cy="180" rx="22" ry="14" fill="none" stroke="#34D399" stroke-width="2"/>
          <circle cx="320" cy="68" r="4" fill="#EF4444"><animate attributeName="opacity" values="1;0.3;1" dur="1.2s" repeatCount="indefinite"/></circle>
          <rect x="32" y="48" width="180" height="12" rx="3" fill="#0F172A" opacity="0.12"/>
          <text x="32" y="88" font-size="13" font-weight="600" fill="#0F172A">Frame-locked sync</text>
          <rect x="32" y="104" width="180" height="8" rx="3" fill="#D1FAE5"/>
          <rect x="32" y="120" width="140" height="8" rx="3" fill="#E2E8F0"/>
          <rect x="428" y="48" width="180" height="12" rx="3" fill="#0F172A" opacity="0.12"/>
          <text x="428" y="88" font-size="13" font-weight="600" fill="#0F172A">Zero wearables</text>
          <rect x="428" y="104" width="180" height="8" rx="3" fill="#D1FAE5"/>
          <rect x="428" y="120" width="120" height="8" rx="3" fill="#E2E8F0"/>
        </svg>
      </div>
    </div>`;
}

export function ugCloudPanel(): string {
  return `
    <div class="ub-panel reveal">
      ${panelChrome('Recordings')}
      <div class="ub-panel__body">
        <svg viewBox="0 0 640 360" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <rect width="640" height="360" fill="#FFFFFF"/>
          <rect x="24" y="24" width="592" height="36" rx="8" fill="#F8FAFC" stroke="#E2E8F0"/>
          <rect x="24" y="72" width="592" height="56" rx="10" fill="#FFFFFF" stroke="#E2E8F0"/>
          <rect x="40" y="88" width="48" height="24" rx="6" fill="#ECFDF5"/>
          <rect x="100" y="90" width="160" height="12" rx="3" fill="#0F172A" opacity="0.15"/>
          <rect x="480" y="90" width="72" height="20" rx="999" fill="#ECFDF5" stroke="#A7F3D0"/>
          <rect x="24" y="140" width="592" height="56" rx="10" fill="#EFF6FF" stroke="#BFDBFE"/>
          <rect x="40" y="156" width="48" height="24" rx="6" fill="#DBEAFE"/>
          <rect x="100" y="158" width="180" height="12" rx="3" fill="#2563EB" opacity="0.35"/>
          <rect x="480" y="158" width="72" height="20" rx="999" fill="#FEF3C7" stroke="#FDE68A"/>
          <rect x="24" y="208" width="592" height="56" rx="10" fill="#FFFFFF" stroke="#E2E8F0"/>
          <rect x="40" y="224" width="48" height="24" rx="6" fill="#F1F5F9"/>
          <rect x="100" y="226" width="140" height="12" rx="3" fill="#CBD5E1"/>
        </svg>
      </div>
    </div>`;
}

export function ugAnnotatePanel(): string {
  return `
    <div class="ub-panel reveal">
      ${panelChrome('Annotation')}
      <div class="ub-panel__body ub-panel__body--split">
        <svg viewBox="0 0 640 360" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <rect width="320" height="360" fill="#0F172A"/>
          <rect x="16" y="16" width="288" height="200" rx="10" fill="#1E293B"/>
          <polyline points="40,180 80,120 120,140 160,90 200,110 240,70 280,90" fill="none" stroke="#10B981" stroke-width="2" stroke-linecap="round"/>
          <rect x="16" y="228" width="288" height="116" rx="10" fill="#1E293B"/>
          <rect x="32" y="280" width="256" height="8" rx="4" fill="#334155"/>
          <rect x="32" y="280" width="120" height="8" rx="4" fill="#10B981"/>
          <rect x="336" y="0" width="304" height="360" fill="#FFFFFF"/>
          <text x="352" y="40" font-size="12" font-weight="600" fill="#0F172A">AI segments</text>
          <rect x="352" y="56" width="260" height="32" rx="8" fill="#ECFDF5" stroke="#A7F3D0"/>
          <rect x="352" y="100" width="260" height="32" rx="8" fill="#FFFFFF" stroke="#E2E8F0"/>
          <rect x="352" y="144" width="260" height="32" rx="8" fill="#FFFFFF" stroke="#E2E8F0"/>
          <rect x="352" y="200" width="120" height="28" rx="999" fill="#10B981"/>
        </svg>
      </div>
    </div>`;
}

export function ugSimPanel(): string {
  return `
    <div class="ub-panel reveal">
      ${panelChrome('Simulation')}
      <div class="ub-panel__body">
        <svg viewBox="0 0 640 360" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <rect width="640" height="360" fill="#FFFFFF"/>
          <rect x="24" y="24" width="280" height="312" rx="12" fill="#0F172A"/>
          <rect x="40" y="40" width="248" height="180" rx="8" fill="#1E293B"/>
          <ellipse cx="164" cy="200" rx="40" ry="24" fill="none" stroke="#34D399" stroke-width="2"/>
          <rect x="320" y="24" width="296" height="312" rx="12" fill="#F8FAFC" stroke="#E2E8F0"/>
          <line x1="380" y1="280" x2="420" y2="180" stroke="#64748B" stroke-width="4" stroke-linecap="round"/>
          <line x1="420" y1="180" x2="480" y2="160" stroke="#64748B" stroke-width="4" stroke-linecap="round"/>
          <line x1="480" y1="160" x2="520" y2="220" stroke="#64748B" stroke-width="4" stroke-linecap="round"/>
          <circle cx="380" cy="280" r="8" fill="#10B981"/>
          <circle cx="520" cy="220" r="8" fill="#2563EB"/>
          <text x="336" y="52" font-size="11" font-weight="600" fill="#64748B">Hand → Arm mapping</text>
        </svg>
      </div>
    </div>`;
}

export function ugLivePanel(): string {
  return `
    <div class="ub-panel ub-panel--compact reveal">
      ${panelChrome('Live view')}
      <div class="ub-panel__body">
        <svg viewBox="0 0 480 280" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <rect width="480" height="280" fill="#FFFFFF"/>
          <rect x="24" y="24" width="432" height="180" rx="12" fill="#0F172A"/>
          <rect x="40" y="40" width="400" height="148" rx="8" fill="#1E293B"/>
          <circle cx="440" cy="44" r="6" fill="#EF4444"><animate attributeName="opacity" values="1;0.4;1" dur="1s" repeatCount="indefinite"/></circle>
          <text x="408" y="48" font-size="9" fill="#FCA5A5">LIVE</text>
          <rect x="24" y="216" width="280" height="40" rx="8" fill="#F8FAFC" stroke="#E2E8F0"/>
          <rect x="40" y="230" width="120" height="12" rx="3" fill="#CBD5E1"/>
          <rect x="320" y="224" width="136" height="28" rx="999" fill="#10B981"/>
        </svg>
      </div>
    </div>`;
}

export function ugReviewPanel(): string {
  return `
    <div class="ub-panel ub-panel--compact reveal">
      ${panelChrome('Review')}
      <div class="ub-panel__body">
        <svg viewBox="0 0 480 280" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <rect width="480" height="280" fill="#FFFFFF"/>
          <rect x="32" y="32" width="416" height="44" rx="8" fill="#F8FAFC" stroke="#E2E8F0"/>
          <rect x="48" y="44" width="140" height="16" rx="4" fill="#0F172A" opacity="0.12"/>
          <rect x="360" y="44" width="72" height="16" rx="999" fill="#ECFDF5" stroke="#A7F3D0"/>
          <rect x="32" y="88" width="416" height="44" rx="8" fill="#FFFFFF" stroke="#E2E8F0"/>
          <rect x="48" y="100" width="120" height="16" rx="4" fill="#CBD5E1"/>
          <rect x="360" y="100" width="72" height="16" rx="999" fill="#EFF6FF" stroke="#BFDBFE"/>
          <rect x="32" y="144" width="416" height="44" rx="8" fill="#FFFFFF" stroke="#E2E8F0"/>
          <rect x="48" y="156" width="100" height="16" rx="4" fill="#E2E8F0"/>
          <rect x="360" y="156" width="72" height="16" rx="999" fill="#FEF3C7" stroke="#FDE68A"/>
        </svg>
      </div>
    </div>`;
}

export function ugContrastPastSvg(): string {
  return `<svg class="ub-contrast-lines ub-contrast-lines--past" viewBox="0 0 200 120" aria-hidden="true">
    <rect x="20" y="20" width="48" height="48" rx="8" fill="#F1F5F9" stroke="#CBD5E1" transform="rotate(-12 44 44)"/>
    <rect x="70" y="36" width="40" height="56" rx="8" fill="#E2E8F0" stroke="#94A3B8" transform="rotate(8 90 64)"/>
    <rect x="120" y="28" width="56" height="40" rx="8" fill="#F8FAFC" stroke="#CBD5E1" transform="rotate(-6 148 48)"/>
    <path d="M10 100 Q60 60 110 90 T190 70" fill="none" stroke="#CBD5E1" stroke-width="1.5" stroke-dasharray="5 8"/>
  </svg>`;
}

export function ugContrastNowSvg(): string {
  return `<svg class="ub-contrast-lines ub-contrast-lines--now" viewBox="0 0 200 120" aria-hidden="true">
    <defs>
      <linearGradient id="ug-now-line" x1="0" y1="0" x2="1" y2="0">
        <stop stop-color="#10B981"/><stop offset="1" stop-color="#2563EB"/>
      </linearGradient>
    </defs>
    <rect x="24" y="32" width="40" height="56" rx="12" fill="#0F172A"/>
    <rect x="32" y="44" width="24" height="36" rx="6" fill="#1E293B"/>
    <circle cx="44" cy="62" r="8" fill="#10B981" opacity="0.85"/>
    <path d="M72 60 H176" stroke="url(#ug-now-line)" stroke-width="2.5" stroke-linecap="round"/>
    <circle cx="176" cy="60" r="6" fill="#10B981" opacity="0.85">
      <animate attributeName="opacity" values="0.5;1;0.5" dur="2s" repeatCount="indefinite"/>
    </circle>
  </svg>`;
}

export const UNITE_GO_MODULE_SVG = `
<svg class="module-svg" viewBox="0 0 400 240" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
  <defs>
    <linearGradient id="ug-mod" x1="0" y1="0" x2="1" y2="1">
      <stop stop-color="#ff9500"/><stop offset="0.5" stop-color="#007aff"/><stop offset="1" stop-color="#5e5ce6"/>
    </linearGradient>
    <filter id="ug-mod-soft"><feDropShadow dx="0" dy="8" stdDeviation="10" flood-opacity="0.14"/></filter>
  </defs>
  <rect x="148" y="28" width="104" height="184" rx="22" fill="rgba(255,255,255,0.94)" stroke="#cbd5e1" stroke-width="2" filter="url(#ug-mod-soft)"/>
  <rect x="158" y="44" width="84" height="148" rx="12" fill="#0f172a"/>
  <circle cx="200" cy="120" r="28" fill="url(#ug-mod)" opacity="0.85"/>
  <ellipse cx="200" cy="148" rx="18" ry="12" fill="none" stroke="rgba(90,200,250,0.7)" stroke-width="2"/>
  <circle cx="108" cy="120" r="4" fill="#ff9500" opacity="0.8"><animate attributeName="opacity" values="0.4;1;0.4" dur="2s" repeatCount="indefinite"/></circle>
  <circle cx="292" cy="120" r="4" fill="#5e5ce6" opacity="0.8"><animate attributeName="opacity" values="0.4;1;0.4" dur="2s" begin="0.5s" repeatCount="indefinite"/></circle>
  <text x="200" y="228" text-anchor="middle" font-family="ui-monospace,monospace" font-size="9" fill="#64748b" letter-spacing="0.08em">CONSUMER · EMBODIED</text>
</svg>`;
